import { Fragment, lazy, PropsWithChildren, Suspense } from 'react';
import Seo from '../Seo';
import Main from '@/shared/Main';
import classNames from 'classnames';
import Div from '@/shared/Div';
import { SeoData } from '@/types/seo';
import Footer from '@/shared/Footer';
import Navbar from '@/shared/crisp/Navbar';
import { useAppConfigContext } from '@/context/AppContext';
import useScreen from '@/hooks/useScreen';
import { useRouter } from 'next/router';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { showAQIBar } from '@/utils/aqi';

type PageLayoutProps = {
  dataTestId?: string;
  mainClassName?: string;
  pageProps?: any;
  hideFooter?: boolean;
  hideHeader?: boolean;
  pageWrapperClassName?: string;
  hideFooterIcons?: boolean;
  seo?: SeoData;
  host?: string;
  showTopMenu?: boolean;
  topPadding?: boolean;
};

const PageLayout = ({
  children,
  pageProps = {},
  dataTestId,
  hideFooter = false,
  hideHeader = false,
  mainClassName,
  pageWrapperClassName,
  seo,
  host,
  showTopMenu,
  topPadding = true,
}: PropsWithChildren<PageLayoutProps>) => {
  const Wrapper = pageWrapperClassName ? Div : Fragment;
  const { state: appConfig, dispatch: appConfigDispatch } = useAppConfigContext();
  const { isAQIEnabled } = useFeatureFlags();
  const { isFlutterClient } = appConfig;
  const { isMobile } = useScreen();

  const router = useRouter();

  const isHideHeader = router?.query?.header === 'false' ? true : false;
  const isHideFooter = router?.query?.footer === 'false' ? true : false;

  if ((appConfig?.saleAssist && isMobile) || isHideHeader) {
    hideHeader = true;
  }
  if (isHideHeader) {
    topPadding = false;
  }
  const wrapperProps = pageWrapperClassName ? { className: pageWrapperClassName } : {};

  return (
    <Wrapper {...wrapperProps}>
      <Seo seo={seo} host={host} />
      {hideHeader ? null : <Navbar showTopMenu={showTopMenu} />}
      <Main
        dataTestId={dataTestId}
        className={classNames('font-primary', mainClassName, {
          'pt-14 lg:pt-18.8': topPadding && (!appConfig.aqiBar || !showAQIBar(router?.pathname)),
          'pb-s4 select-none': isFlutterClient,
          'pt-[97px] lg:pt-[112px]': appConfig.aqiBar && topPadding && showAQIBar(router?.pathname),
        })}
      >
        {children}
      </Main>
      {hideFooter || isFlutterClient || isHideFooter ? null : <Footer />}
    </Wrapper>
  );
};

export default PageLayout;
